import { Dropdown, Tooltip } from 'antd';
import { Check, Monitor, Moon, MoonStar, Sun } from 'lucide-react';

import { useTheme } from '../../theme';
import { useI18n } from '../../i18n';

const ICONS = { system: Monitor, light: Sun, dark: Moon, night: MoonStar };

export const ThemeSwitcher = () => {
  const { mode, setMode, modes } = useTheme();
  const { t } = useI18n();
  const Icon = ICONS[mode];

  return (
    <Dropdown
      trigger={['click']}
      placement='bottomRight'
      dropdownRender={() => (
        <div className='ant-dropdown-menu' role='menu' aria-label={t('header.theme')}>
          <div className='ant-dropdown-menu-item-group-title'>{t('header.theme')}</div>
          <div className='wm-theme-options'>
            {modes.map(key => {
              const ItemIcon = ICONS[key];
              const active = key === mode;
              return (
                <button
                  key={key}
                  type='button'
                  role='menuitemradio'
                  aria-checked={active}
                  className={`wm-theme-option${active ? ' is-active' : ''}`}
                  onClick={() => setMode(key)}
                >
                  <span className={`wm-theme-preview wm-theme-preview--${key}`}>
                    <i />
                    <i />
                    <i />
                  </span>
                  <span className='wm-theme-option__label'>
                    <ItemIcon size={14} strokeWidth={1.75} />
                    {t(`theme.${key}`)}
                    {active && <Check size={14} strokeWidth={2.25} style={{ marginLeft: 'auto' }} />}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    >
      <Tooltip title={t('header.theme')} placement='bottom'>
        <button type='button' className='wm-icon-btn' aria-label={t('header.theme')}>
          <Icon size={18} strokeWidth={1.75} />
        </button>
      </Tooltip>
    </Dropdown>
  );
};
